<script>
/**
 * ****************************************************************************
 * @description     :   Header
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import libraries
 */
import { mapState, mapMutations, mapActions } from 'vuex';
//import { ref } from 'vue';
import jwt_decode from 'jwt-decode';
// import repository from './repository';
import helpers from '@/utils/helpers';
import store from '@/store';
import changePassStore from '@/shared/header/store';
import MessageComponent from './components/MessageComponent.vue';
/**
 * import template
 */
import template from './template.html';
import label from './label';
import './style.scss';
import messages, { MSG_TITLE, MSG_TYPE, MSG_BUTTON } from '@/utils/messages';
import popupMail from '@/views/popupSearch/popup_mail';
import Customer from '@/views/popupSearch/popup_customer';
import Branch from '@/views/popupSearch/popup_branch';
import User from '@/views/popupSearch/popup_user';
import AnsProgressBar from '@/components/ansProgressBar/index.vue';
import { password_input_rule } from '@/utils/constants';
import defaultAvatar from '@/shared/header/img_user.png';
import moment from 'moment';

/**
 * Define main layout
 */
const Header = {
    name: 'Menu',
    template: template,
    emits: ['clickBtnLeftMenu'],
    created() {
        // const routeName = this.$route.name;
        // if (routeName.includes('MNG')) {
        //     this.authority = 1;
        // } else if (routeName.includes('CUS')) {
        //     this.authority = 2;
        // }
        this.checkTimePass();
        this.modeDisabled = helpers.checkAuthorityMode(this.$route.name);
        moment.locale('ja');
    },
    components: {
        popupMail,
        Customer,
        Branch,
        User,
        AnsProgressBar,
        MessageComponent
    },
    beforeCreate() {
        if (!store.hasModule('header')) {
            store.registerModule('header', changePassStore);
        }
    },
    props: {
        isExistsLeftMenu: {
            type: Boolean,
            default: true
        },
        isShowBtnLeftMenu: {
            type: Boolean,
            default: true
        },
        isPinIconLeftMenu: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        '$route.params'() {
            if (this.$route.name.includes('CUS') && localStorage.getItem('userInfo')) {
                this.postCommonHeader();
            }
        }
    },
    computed: {
        ...mapState('app', [
            'user',
            'header',
            'messageCount',
            'isBgHeaderDefault',
            'permissions',
            'isLogout',
            'isLogin',
            'countNotify',
            'notification',
            'zoom',
            'isShowLeftMenu',
            'order_number'
        ]),
        ...mapState('header', ['timerHistory', 'statusDiv', 'statusName', 'currentStatusName', 'setUsersData']),
        isClient() {
            try {
                var decoded = jwt_decode(localStorage.getItem('token'));
                if ((decoded.loginid + '').indexOf('@') > -1) {
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                console.log('isClient: ' + e.message);
                return true;
            }
        },
        renderCustomerLoginName() {
            return `${this.user.contact_last_name ?? ''} ${this.user.contact_first_name ?? ''}` + (this.mode == 1 ? '' : ' 様');
        },
        renderLoginName() {
            return this.user.user_name ? this.user.user_name : '';
        },
        isMobile() {
            return helpers.checkIfMobile();
        },
        disableButton() {
            if (this.data.oldPassword != '' && this.data.newPassword != '' && this.data.newPasswordConfirm != '') {
                return false;
            } else {
                return true;
            }
        },
        checkMaxlength() {
            let maxLength = 20;
            if (this.authority == 1) {
                return maxLength;
            }
            if (this.authority == 2) {
                maxLength = 100;
            }
            return maxLength;
        },
        // imageLink() {
        //     return helpers.renderPath(this.user.image);
        // },
        version() {
            return process.env.VUE_APP_VERSION;
        }
    },
    data() {
        return {
            label: label,
            isPopupNotify: false,
            isPopupPassword: false,
            isPopupMail: false,
            isPopupMailToDo: false,
            isShowTimeCard: false,
            popupHidden: '',
            authority: '',
            data: {
                oldPassword: '',
                newPassword: '',
                newPasswordConfirm: ''
            },
            validRules: {
                oldPassword: 'required',
                newPassword: 'required',
                newPasswordConfirm: 'required'
            },
            data2: {
                user_cd: '',
                user_name: '',
                customer_cd: '',
                customer_name: '',
                branch_cd: '',
                branch_name: ''
            },
            isPopupVisible: {},
            popupName: '', // Tên popup hiện tại
            popup: null, // Component của modal
            initData: {}, // Dữ liệu khởi tạo của popup
            password_input_rule: password_input_rule,
            mode: 0,
            date: {
                day: '',
                month: '',
                year: ''
            },
            modeDisabled: false,
            cusRole: 0,
            dateLimit: '',
            isLimit: '',
            errors: [],
            defaultAvatar,
            currentTimes: null, // Thời điểm server khi fetch
            now: moment(this.currentTimes),
            localMoment: null,
            timer: null,
            hourMinStr: '00:00',
            secondStr: '00'
        };
    },
    mounted() {
        this.getNotify({ code: '2' });
        const noPopUp401Pages = [
            'MNG_Login',
            'CUS_Login',
            'CUS_Register001',
            'CUS_Register002',
            'CUS_Register003',
            'CUS_Register004',
            'CUS_Register005',
            'CUS_Start001',
            'CUS_Start011',
            'CUS_Start002',
            'CUS_Start003',
            'CUS_Start004',
            'CUS_Start005',
            'CUS_Start021',
            'CUS_Start022',
            'CUS_Start023',
            'CUS_Start024'
        ];
        if (this.$route.name.includes('CUS') && !noPopUp401Pages.includes(this.$route.name) && localStorage.getItem('userInfo')) {
            this.postCommonHeader();
        }

        var menuUser = document.getElementById('dropdownUser2');
        if (menuUser) {
            menuUser.classList.remove('show');
            menuUser.setAttribute('aria-expanded', 'false');
        }

        if (localStorage.getItem('userInfo')) {
            this.cusRole = JSON.parse(localStorage.getItem('userInfo')).cusRole;
            // this.getImage(
            //     JSON.parse(localStorage.getItem('userInfo')).path_image
            // );
        }

        if (this.$route.name.includes('CUS')) {
            this.mode = 2;
        } else {
            this.mode = 1;
        }

        this.date.day = moment.utc().format('DD');
        this.date.month = moment.utc().format('MM');
        this.date.year = moment.utc().format('YYYY');
        // if (this.authority == 1) {
        //     this.isPopupMail = true;
        // } else {
        //     this.isPopupMail = false;
        // }
        // document.addEventListener('hidden.bs.modal', this.onHiddenMailPopup);
        document.addEventListener('keydown', this.handleKeydown);
        const authorityNumber = localStorage.getItem('authority');
        if (authorityNumber) {
            this.authority = JSON.parse(authorityNumber);
        }

        // Tạo moment từ server
        helpers
            .getCurrentTime()
            .then((result) => {
                this.currentTimes = result;
                this.serverMoment = moment.utc(this.currentTimes);
                this.localMoment = this.serverMoment.clone();
                // Cập nhật lần đầu
                this.updateTimeParts();
            })
            .catch(console.error);
        //Run second
        this.timer = setInterval(() => {
            if (!this.localMoment) return;
            this.localMoment.add(1, 'second');
            this.updateTimeParts();
        }, 1000);
        /*
        setInterval(() => {
            helpers
                .getCurrentTime()
                .then((result) => {
                    this.currentTimes = result;
                    this.serverMoment = moment(this.currentTimes);
                    this.localMoment = this.serverMoment.clone();
                    // Cập nhật lần đầu
                    this.updateTimeParts();
                })
                .catch(console.error);
        }, 30 * 1000); // 30s reload
        */
        // đồng bộ ngay khi tab active
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                helpers
                    .getCurrentTime()
                    .then((result) => {
                        this.currentTimes = result;
                        this.serverMoment = moment.utc(this.currentTimes);
                        this.localMoment = this.serverMoment.clone();
                        // Cập nhật lần đầu
                        this.updateTimeParts();
                    })
                    .catch(console.error);
            }
        });
    },
    unmounted() {
        // document.removeEventListener('hidden.bs.modal', this.onHiddenMailPopup);
        document.removeEventListener('keydown', this.handleKeydown);
        //clearInterval(timer);
    },
    methods: {
        ...mapActions('app', ['getNotify', 'saveNotify', 'updatePassWord', 'postCommonHeader', 'setStatus']),
        ...mapMutations('app', ['resetAppState', 'setLogout', 'showHeaderError', 'hideHeaderError', 'showModalMessage', 'hideModalMessage']),
        ...mapActions('header', ['changePassWordCUS', 'changePassWordMNG', 'getImage']),
        ...mapMutations('header', ['setStatus']),
        changeProfile() {
            if (this.$route.name.includes('CUS')) {
                this.$router.push({ name: 'CUS_System002' });
            } else {
                this.$router.push({ name: 'MNG_System006' });
            }
        },
        logout: function () {
            // remove color settings in localstorage
            localStorage.removeItem('mainColor');
            localStorage.removeItem('subColor');
            localStorage.removeItem('backColor');
            // this.setLogout(true);
            this.$router.push('/logout');
        },
        // closePopup() {
        //     this.notify();
        // },
        onClickBtnLeftMenu() {
            this.$emit('clickBtnLeftMenu');
        },
        addNewTimer() {
            this.timerHistory.timer_history.push({ no: '', timed: this.hourMinStr, status_div: this.statusDiv, status_name: this.statusName });
        },
        onClickBtnKintai() {
            this.addNewTimer();
            if (this.statusDiv === '0') {
                this.setStatus({ div: '1', currentName: '出勤', name: '退勤' });
            } else {
                this.setStatus({ div: '0', currentName: '退勤', name: '出勤' });
            }
        },
        changePass() {
            let errorMsg = helpers.renderMsgErr(this.errors);
            if (errorMsg != '') {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: errorMsg,
                    okText: MSG_BUTTON.okText
                });
            } else {
                this.showModalMessage({
                    type: MSG_TYPE.CONFIRM,
                    title: MSG_TITLE.C002,
                    content: messages.C002,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            if (this.authority == 1) {
                                this.changePassWordCUS({
                                    body: {
                                        ...this.data
                                    },
                                    callback: (response) => {
                                        console.log('response', response);
                                        this.showModalMessage({
                                            type: MSG_TYPE.SUCCESS,
                                            title: MSG_TITLE.S002,
                                            content: messages.S002,
                                            okText: MSG_BUTTON.okText,
                                            callback: () => {
                                                this.close();
                                                localStorage.setItem('password_setting_date', new Date());
                                                this.$router.go();
                                            }
                                        });
                                    },
                                    onErrorValidate: (errors) => {
                                        this.addError({
                                            name: 'oldPassword',
                                            message: errors
                                        });
                                    },
                                    onError: (errorMessage) => {
                                        this.showHeaderError([errorMessage ?? messages.E999]);
                                    }
                                });
                            }
                            if (this.authority == 2) {
                                this.changePassWordMNG({
                                    body: {
                                        ...this.data
                                    },
                                    callback: (response) => {
                                        console.log('response', response);
                                        this.showModalMessage({
                                            type: MSG_TYPE.SUCCESS,
                                            title: MSG_TITLE.S001,
                                            content: messages.S002,
                                            okText: MSG_BUTTON.okText,
                                            callback: () => {
                                                this.close();
                                                localStorage.setItem('password_setting_date', new Date());
                                                this.$router.go();
                                            }
                                        });
                                    },
                                    onErrorValidate: (errors) => {
                                        this.addError({
                                            name: 'oldPassword',
                                            message: errors
                                        });
                                    },
                                    onError: (errorMessage) => {
                                        this.showHeaderError([errorMessage ?? messages.E999]);
                                    }
                                });
                            }
                        }
                    }
                });
            }
        },
        close() {
            this.isPopupPassword = false;
            this.data.oldPassword = '';
            this.data.newPassword = '';
            this.data.newPasswordConfirm = '';
        },
        validatePass() {
            const oldPassword = document.getElementById('oldPassword');
            const newPassword = document.getElementById('newPassword');
            const newPasswordConfirm = document.getElementById('newPasswordConfirm');
            const textOld = document.getElementById('mess-text-err-old');
            const textNew = document.getElementById('mess-text-err-new');
            const textConfirm = document.getElementById('mess-text-err-confirm');
            // textOld.value = '';
            textOld.innerHTML = '';
            textNew.innerHTML = '';
            textConfirm.innerHTML = '';
            oldPassword?.classList.remove('require-input');
            newPassword?.classList.remove('require-input');
            newPasswordConfirm?.classList.remove('require-input');
            if (helpers.isNullOrEmpty(this.data.oldPassword)) {
                oldPassword.focus();
                oldPassword?.classList.add('require-input');
                textOld.textContent += '旧パスワードを入力してください。';
                return false;
            } else if (helpers.isNullOrEmpty(this.data.newPassword)) {
                newPassword.focus();
                newPassword?.classList.add('require-input');
                textNew.textContent += '新パスワードを入力してください。';
                return false;
            } else if (!helpers.isValidPassword(this.data.newPassword)) {
                newPassword.focus();
                newPassword?.classList.add('require-input');
                textNew.textContent += messages.E164;
                return false;
            } else if (this.data.oldPassword == this.data.newPassword) {
                newPassword.focus();
                newPassword?.classList.add('require-input');
                textNew.textContent += '新パスワードと旧パスワードが同じです。';
                return false;
            } else if (helpers.isNullOrEmpty(this.data.newPasswordConfirm)) {
                newPasswordConfirm.focus();
                newPasswordConfirm?.classList.add('require-input');
                textConfirm.textContent += '新パスワード(確認)を入力してください。';
                return false;
            } else if (this.data.newPassword != this.data.newPasswordConfirm) {
                newPasswordConfirm.focus();
                newPasswordConfirm?.classList.add('require-input');
                textConfirm.textContent += '新パスワードと新パスワード(確認)が一致しません。';
                return false;
            }
            return true;
        },
        handleKeydown(event) {
            if (event.keyCode === 27) {
                const popups = document.querySelectorAll('.popup-overlay');
                if (popups.length > 0) {
                    const lastPopup = popups[popups.length - 1];
                    const popupName = lastPopup.getAttribute('popup-name');
                    if (popupName == 'PopupMail') {
                        this.closePopupMail();
                    } else if (popupName == 'PopupChangePassword') {
                        if (this.isLimit == 'true') {
                            this.closePopupChangePassword();
                        }
                    } else if (popupName == 'PopupNotify') {
                        this.closePopupNotify();
                    } else if (popupName == 'PopupMailTodo') {
                        this.closePopupMailToDo();
                    } else if (popupName == 'PopupShowTimeCard') {
                        this.closePopupTimeCard();
                    }
                }
            }
        },
        // onHiddenMailPopup() {
        //     if (this.popupHidden == 'popupMail') {
        //         this.$refs['btn-open-popup-mail'].blur();
        //     } else if (this.popupHidden == 'popupUser') {
        //         let button = document.querySelector(
        //             '#btn-open-popup-user-in-mail'
        //         );
        //         let input = document.querySelector('#input-user-in-mail');
        //         if (button != null) {
        //             button.blur();
        //             setTimeout(() => {
        //                 input.focus();
        //             }, 300);
        //         }
        //     } else if (this.popupHidden == 'popupCustomer') {
        //         let button = document.querySelector(
        //             '#btn-open-popup-customer-in-mail'
        //         );
        //         let input = document.querySelector('#input-customer-in-mail');
        //         if (button != null) {
        //             button.blur();
        //             setTimeout(() => {
        //                 input.focus();
        //             }, 300);
        //         }
        //     } else if (this.popupHidden == 'popupBranch') {
        //         let button = document.querySelector(
        //             '#btn-open-popup-branch-in-mail'
        //         );
        //         let input = document.querySelector('#input-branch-in-mail');
        //         if (button != null) {
        //             button.blur();
        //             setTimeout(() => {
        //                 input.focus();
        //             }, 300);
        //         }
        //     }
        // },
        // clickButtonClose(popupName) {
        //     this.popupHidden = popupName;
        //     // popup change password
        //     if (popupName == 'popupChangePassword') {
        //         this.isPopupPassword = false;
        //         this.data.oldPassword = '';
        //         this.data.newPassword = '';
        //         this.data.newPasswordConfirm = '';
        //     } else if (popupName == 'popupNotify') {
        //         this.notify();
        //     }
        // },
        // closeModal() {
        //     // this.$refs['btn-close-user-popup'].click();
        //     // this.$refs['btn-close-customer-popup'].click();
        //     // this.$refs['btn-close-branch-popup'].click();
        //     let modal = document.querySelector('.modal.show');
        //     if (modal != null) {
        //         let modalId = modal.id;
        //         if (modalId == 'popupMail') {
        //             this.popupHidden = 'popupMail';
        //             this.$refs['btn-close-mail-popup'].click();
        //         } else if (modalId == 'popupUser') {
        //             this.popupHidden = 'popupUser';
        //             this.$refs['btn-close-user-popup'].click();
        //         } else if (modalId == 'popupChangePassword') {
        //             this.popupHidden = 'popupChangePassword';
        //             this.$refs['btn-close-popup-password'].click();
        //         } else if (modalId == 'popupCustomer') {
        //             this.popupHidden = 'popupCustomer';
        //             this.$refs['btn-close-customer-popup'].click();
        //         } else if (modalId == 'popupBranch') {
        //             this.popupHidden = 'popupBranch';
        //             this.$refs['btn-close-branch-popup'].click();
        //         }
        //     }
        // },
        // closeModalMail() {
        //     setTimeout(() => {
        //         this.$refs.popupModalEmail.resetData();
        //     }, 300);
        // },
        openPopupMail() {
            this.isPopupMail = true;
            this.$nextTick(() => {
                let popupMail = this.$refs['popup-mail'];
                // focus first input
                if (popupMail) {
                    const enabledInputOrSelect = popupMail.querySelector('input:not([disabled]), select:not([disabled])');
                    if (enabledInputOrSelect) {
                        enabledInputOrSelect.focus();
                    }
                }
            });
            document.body.classList.add('modal-open-popup-mail');
        },
        closePopupMail() {
            this.isPopupMail = false;
            this.$nextTick(() => {
                this.$refs['btn-open-popup-mail'].blur();
            });
            document.body.classList.remove('modal-open-popup-mail');
        },
        changePassWord() {
            this.isPopupPassword = true;
            this.$nextTick(() => {
                let popupChangePassword = this.$refs['popup-change-password'];
                // focus first input
                if (popupChangePassword) {
                    const enabledInputOrSelect = popupChangePassword.querySelector('input:not([disabled]), select:not([disabled])');
                    if (enabledInputOrSelect) {
                        enabledInputOrSelect.focus();
                    }
                }
            });
        },
        moveToHelpCenter() {
            window.open('/CUS_FAQ', '_blank');
        },
        closePopupChangePassword() {
            this.isPopupPassword = false;
            this.data.oldPassword = '';
            this.data.newPassword = '';
            this.data.newPasswordConfirm = '';
            this.removeError('oldPassword');
            this.removeError('newPassword');
            this.removeError('newPasswordConfirm');
            localStorage.setItem('password_setting_date', new Date());
        },
        openPopupNotify() {
            // this.isPopupNotify = true;
        },
        closePopupNotify() {
            this.isPopupNotify = false;
            // btn-notification
            this.$nextTick(() => {
                this.$refs['btn-notification'].blur();
            });
        },
        referData(data) {
            this.data2.user_cd = data.user_cd ?? '';
            this.data2.user_name = data.user_name ?? '';
            this.data2.customer_cd = data.customer_cd ?? '';
            this.data2.customer_name = data.customer_name ?? '';
            this.data2.branch_cd = data.branch_cd ?? '';
            this.data2.branch_name = data.branch_name ?? '';
        },
        openPopupMailToDo() {
            this.isPopupMailToDo = true;

            this.$nextTick(() => {
                let popupTodo = this.$refs['popup-mail-todo'];
                // focus todo
                if (popupTodo) {
                    const focusInput = popupTodo.querySelector('#focus');
                    if (focusInput) {
                        focusInput.focus();
                    }
                }
            });
        },
        closePopupMailToDo() {
            this.isPopupMailToDo = false;
            this.$nextTick(() => {
                this.$refs['btn-open-popup-todo'].blur();
            });
        },
        sendMailToDo() {
            document.getElementById('modal-no-backdrop').style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C010,
                content: 'メッセージを送信しますか？',
                cancelText: 'いいえ',
                okText: 'はい',
                callback: (ok) => {
                    console.log(ok, messages);
                    this.showModalMessage({
                        type: MSG_TYPE.SUCCESS,
                        title: '報告',
                        content: '送信完了しました。',
                        okText: 'OK'
                    });
                }
            });
        },
        // notSamePasswords() {
        //     if (this.data.password_confirmation && this.data.password) {
        //         if (this.data.password !== this.data.password_confirmation) {
        //             return false;
        //         } else {
        //             return true;
        //         }
        //     } else {
        //         return false;
        //     }
        // },
        checkPassword() {
            this.data.newPassword = this.data.newPassword.trim();
            this.data.newPasswordConfirm = this.data.newPasswordConfirm.trim();
            this.isValidPassword = true;
            const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#])[A-Za-z\d@$#]{10,}$/;
            this.isValidPassword = regex.test(this.data.newPassword);
            if (this.data.newPassword) {
                if (!this.isValidPassword) {
                    this.addError({
                        name: 'newPassword',
                        message: 'パスワードの形式が正しくありません。'
                    });
                } else {
                    this.removeError('newPassword');
                }
            } else {
                this.removeError('newPassword');
            }
            if (this.data.newPasswordConfirm && this.data.newPassword) {
                if (this.data.newPassword !== this.data.newPasswordConfirm) {
                    this.addError({
                        name: 'newPasswordConfirm',
                        message: 'パスワードとパスワード(確認用)が一致しません。'
                    });
                } else {
                    this.removeError('newPasswordConfirm');
                }
            } else {
                this.removeError('newPasswordConfirm');
            }
            if (this.data.newPassword == this.data.oldPassword) {
                this.addError({
                    name: 'newPassword1',
                    message: '新パスワードが、旧パスワードと同じです。変更して下さい。'
                });
            } else {
                this.removeError('newPassword1');
            }
        },
        addError(message) {
            this.errors.push(message);
        },
        removeError(fieldName) {
            this.errors = this.errors.filter((e) => e.name !== fieldName);
        },
        checkOldPass() {
            this.data.oldPassword = this.data.oldPassword.trim();
            if (this.user.password != this.data.oldPassword && this.data.oldPassword) {
                this.addError({
                    name: 'oldPassword',
                    message: '旧パスワードが違います。'
                });
            } else {
                this.removeError('oldPassword');
            }

            if (this.data.newPassword == this.data.oldPassword) {
                this.addError({
                    name: 'newPassword1',
                    message: '新パスワードが、旧パスワードと同じです。変更して下さい。'
                });
            } else {
                this.removeError('newPassword1');
            }
        },
        checkTimePass() {
            const exceptListScreen = [
                '/404',
                '/CUS_Register001',
                '/CUS_Register002',
                '/CUS_Register003',
                '/CUS_Register004',
                '/CUS_Register005',
                '/CUS_Start001',
                '/CUS_Start002',
                '/CUS_Start003',
                '/CUS_Start004',
                '/CUS_Start005',
                '/CUS_Start011',
                '/view_log',
                '/view_log/detail/',
                'CUS_System903',
                'MNG_System903'
            ];
            if (!exceptListScreen.includes(window.location.pathname)) {
                let dateData = localStorage.getItem('password_setting_date');
                let datePass = moment.utc(dateData, 'YYYY-MM-DD HH:mm:ss.SSSSSSS', true);
                let dateNow = moment.utc();
                let dayDiff = dateNow.diff(datePass, 'days');
                if (80 <= dayDiff && dayDiff <= 90) {
                    this.changePassWord();
                    const date = moment(datePass.add(90, 'days')).format('YYYY年MM月DD日');
                    this.dateLimit = date;
                    this.isLimit = 'true';
                }
                if (dayDiff > 90) {
                    this.showModalMessage({
                        type: MSG_TYPE.WARNING,
                        title: MSG_TITLE.W001,
                        content: messages.W002,
                        cancelText: MSG_BUTTON.cancelText,
                        callback: (ok) => {
                            if (ok) {
                                this.changePassWord();
                                this.isLimit = 'false';
                            }
                        }
                    });
                }
            }
        },
        checkPricingTablePdf() {
            const userInfo = JSON.parse(localStorage.getItem('userInfo'));
            return userInfo && userInfo.pricing_table_pdf && userInfo.pricing_table_pdf !== '';
        },
        pricingTable() {
            const userInfo = JSON.parse(localStorage.getItem('userInfo'));
            if (userInfo.pricing_table_pdf) {
                const { href } = this.$router.resolve({
                    name: 'PreviewPdf',
                    params: {
                        file_name: userInfo.pricing_table_pdf,
                        path: userInfo.pricing_table_pdf,
                        type: 5
                    }
                });
                window.open(`${window.location.origin}${href}`, '_blank');
            }
        },
        openPopupTimeCard() {
            this.isShowTimeCard = true;
            this.$nextTick(() => {
                let popupTodo = this.$refs['popup-time-card'];
                // focus todo
                if (popupTodo) {
                    const focusInput = popupTodo.querySelector('#focus');
                    if (focusInput) {
                        focusInput.focus();
                    }
                }
            });
            document.body.classList.add('modal-open-popup-timer-card');
        },
        closePopupTimeCard() {
            this.isShowTimeCard = false;
            document.body.classList.remove('modal-open-popup-timer-card');
        },
        updateTimeParts() {
            this.dateStr = this.localMoment.format('YYYY年MM月DD日 (ddd)');
            this.hourMinStr = this.localMoment.format('HH:mm');
            this.secondStr = this.localMoment.format('ss');
        }
    }
};
export default Header;
</script>
